import React from 'react';

export default function ModalInfo ({ children, hideModal }) {
  return (
    <div className='modalStyling' onClick={hideModal}>
      {children}
    </div>
  );
}
